import * as classnames from 'classnames/bind'
import * as React from 'react'
import { FC } from 'react'
import styles from './button.module.scss'

type Props = {
  children?: React.ReactNode
  className?: string
  disabled?: boolean | false
  raised?: boolean | false
  onClick?: () => void
  onFocus?: () => void
  onBlur?: () => void
}

const cx = classnames.bind(styles)
const Button: FC<Props> = ({ children, className, disabled, raised, onClick, onFocus, onBlur }) => {
  if (!children) {
    return null
  }

  return (
    <button
      type="button"
      className={cx(styles.button, className, { raised })}
      disabled={disabled}
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      {children}
    </button>
  )
}

export default Button
